let bSupportCenterHelperLoaded = false; /**WEBMESS-540: boolean variable to determine if the SupportCenterHelper plugin is already initialized or not, when the Genesys.init command is getting called without page refresh*/

function initSupportCenterHelper(config, GenesysJS) {
  const supportCenterConfig = config.deploymentConfig.supportCenter || {};

  if (true === supportCenterConfig.enabled && !bSupportCenterHelperLoaded) {
    bSupportCenterHelperLoaded = true;
    GenesysJS.log('SupportCenter enabled. Start SupportCenterHelper configure.');

    GenesysJS.subscribe('SupportCenterHelper.ready', () => {
      GenesysJS.command('SupportCenterHelper.configure', config);
    });
  }
}

export default initSupportCenterHelper;
